'use es6';

import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import PageLayoutOptions from '../constants/PageLayoutOptions';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { getPageLayoutOptionText } from '../utils/langUtils';
var PAGE_LAYOUT_OPTIONS = [PageLayoutOptions.ALL, PageLayoutOptions.SINGLE_COLUMN, PageLayoutOptions.TWO_COLUMN, PageLayoutOptions.THREE_COLUMN, PageLayoutOptions.FOUR_COLUMN, PageLayoutOptions.MULTI_ROW];
export default createReactClass({
  displayName: "PageLayoutFilter",
  mixins: [ComponentWithPartials, PureRenderMixin],
  propTypes: {
    onGoodFilterChange: PropTypes.func.isRequired,
    pageLayoutFilter: PropTypes.string.isRequired
  },
  getGoodFilterChangeHandlerForPageLayout: function getGoodFilterChangeHandlerForPageLayout(layout) {
    var params = {};
    params[GoodFiltersAndPage.PAGE_LAYOUT] = layout;
    return this.props.onGoodFilterChange(params);
  },
  renderLayoutOption: function renderLayoutOption(layout) {
    return React.createElement(UIRadioInput, {
      checked: this.props.pageLayoutFilter === layout,
      "data-test-id": "page-layout-input",
      key: layout,
      onChange: this.partial(this.getGoodFilterChangeHandlerForPageLayout, layout),
      name: "pageLayout",
      size: "small",
      value: layout
    }, getPageLayoutOptionText(layout));
  },
  render: function render() {
    return React.createElement(UIFormControl, {
      className: "integrate-page-layout-filter",
      label: getPageLayoutOptionText('title')
    }, React.createElement(UIToggleGroup, {
      name: "pageLayout"
    }, PAGE_LAYOUT_OPTIONS.map(this.renderLayoutOption)));
  }
});